import { Component } from '@angular/core';
import { SyncService } from 'src/app/core/sync/sync.service';

@Component({
	selector: 'app-main-layout',
	templateUrl: './main-layout.component.html',
	styleUrls: ['./main-layout.component.scss'],
})
export class MainLayoutComponent {

	pageTitle = 'MTPro';

	constructor(
		private syncService: SyncService,
	) { }

	get isBlockingSync$() {
		return this.syncService.isBlockingSync$;
	}

	onRouteActivate(pageComponentReference: any) {
		this.pageTitle = pageComponentReference.pageTitle;
	}

}
